import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AgentOptions } from 'mbs-ui-shared@models/AgentOptions';
import { PagedResponse } from 'mbs-ui-shared@models/Paging';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AgentOptionsService {
  private http = inject(HttpClient);

  getDefault(): Observable<AgentOptions> {
    return this.http.get<PagedResponse<AgentOptions>>('api/settings', { params: { type: 'default' } }).pipe(map((res) => res.data[0]));
  }

  getByKey(id: string): Observable<AgentOptions> {
    return this.http.get<AgentOptions>(`api/settings/${id}`);
  }

  add(entity: AgentOptions): Observable<AgentOptions> {
    return this.http.post<AgentOptions>('api/settings', entity);
  }

  update(entity: AgentOptions): Observable<AgentOptions> {
    return this.http.put<AgentOptions>(`api/settings/${entity.id}`, entity);
  }

  // deprecated from rmm16
  getGlobalAgentOptions(): Observable<any> {
    return this.http.get('/api/notification-options/rmm');
  }

  getGlobalAgentOptionsDeepInstinct(): Observable<any> {
    return this.http.get('/api/notification-options/deepInst');
  }
}
